import { EntryPointFrontend } from '@autoinformer/models/worksheet-actions/frontend/entry-point';
import { EntryPointBackend } from '@autoinformer/models/worksheet-actions/backend/entry-point';

import { MenuFrontend } from '@autoinformer/models/worksheet-actions/frontend/menu';
import { MenuBackend } from '@autoinformer/models/worksheet-actions/backend/menu';

import { PlaybackFrontend } from '@autoinformer/models/worksheet-actions/frontend/playback';
import { PlaybackBackend } from '@autoinformer/models/worksheet-actions/backend/playback';

import { PostbackFrontend } from '@autoinformer/models/worksheet-actions/frontend/postback';
import { PostbackBackend } from '@autoinformer/models/worksheet-actions/backend/postback';

// export const LIST_ACTION_TYPES = ['start', 'media', 'postback', 'menu'];
export const LIST_ACTION_TYPES = ['media', 'postback', 'menu'];

export class WorksheetActionModelSelector {
  static getFrontendModel(item) {
    const { type } = item;

    return WorksheetActionModelSelector.getFrontendModelByType(type, item);
  }

  static getFrontendModelByType(type, item) {
    if (type === 'start') {
      return new EntryPointFrontend(item);
    } else if (type === 'menu') {
      return new MenuFrontend(item);
    } else if (type === 'media') {
      return new PlaybackFrontend(item);
    } else if (type === 'postback') {
      return new PostbackFrontend(item);
    }
  }

  static getBackendModel(item) {
    const { type } = item;
    return WorksheetActionModelSelector.getBackendModelByType(type, item);
  }

  static getBackendModelByType(type, item) {
 
   if (type === 'start') {
      return new EntryPointBackend(item);
    } else if (type === 'menu') {
      return new MenuBackend(item);
    } else if (type === 'media') {
      return new PlaybackBackend(item);
    } else if (type === 'postback') {
      return new PostbackBackend(item);
    }
  }
}
